/* Instructions directory — client-side filtering.

   The 67 cards and their 26 group headings are server-rendered; this only
   hides and shows them. Nothing here creates content, so with the script off
   the page is the full directory — which is what live is, and what a crawler
   gets either way.

   The filter panel ships `hidden` and is revealed here, because a search box
   and three rows of chips that do nothing are worse than no controls at all.
   The card data comes from data-brand / data-stage / data-tags, written by
   tools/port-instructions-dir.py off the kicker and pills each card already
   displays — no runtime string-parsing of visible copy. */
(function () {
  'use strict';

  var root = document.querySelector('.rd-instr');
  if (!root) return;

  var panel = root.querySelector('[data-rd-filters]');
  var input = root.querySelector('#rd-instr-q');
  var countEl = root.querySelector('[data-rd-count]');
  var emptyEl = root.querySelector('[data-rd-empty]');
  var chips = [].slice.call(root.querySelectorAll('[data-rd-facet]'));
  var clears = [].slice.call(root.querySelectorAll('[data-rd-clear]'));
  var groups = [].slice.call(root.querySelectorAll('[data-rd-group]'));
  var cards = [].slice.call(root.querySelectorAll('[data-rd-card]'));
  if (!cards.length) return;

  var strings = {
    one: root.getAttribute('data-count-one') || 'product',
    many: root.getAttribute('data-count-many') || 'products'
  };

  // Search haystack per card, built once.
  cards.forEach(function (c) {
    c._hay = [
      c.getAttribute('data-brand') || '',
      c.getAttribute('data-stage') || '',
      (c.getAttribute('data-tags') || '').replace(/\|/g, ' '),
      (c.textContent || '')
    ].join(' ').toLowerCase();
  });

  var active = { brand: [], stage: [], type: [] };
  var query = '';

  function matches(card) {
    if (query && card._hay.indexOf(query) === -1) return false;
    if (active.brand.length && active.brand.indexOf(card.getAttribute('data-brand')) === -1) return false;
    if (active.stage.length && active.stage.indexOf(card.getAttribute('data-stage')) === -1) return false;
    if (active.type.length) {
      var tags = (card.getAttribute('data-tags') || '').split('|');
      var hit = active.type.some(function (t) { return tags.indexOf(t) !== -1; });
      if (!hit) return false;
    }
    return true;
  }

  function apply() {
    var total = 0;
    groups.forEach(function (g) {
      var n = 0;
      [].slice.call(g.querySelectorAll('[data-rd-card]')).forEach(function (c) {
        var ok = matches(c);
        c.hidden = !ok;
        if (ok) n++;
      });
      // A group whose every card is filtered out has nothing to head.
      g.hidden = n === 0;
      var badge = g.querySelector('[data-rd-groupcount]');
      if (badge) badge.textContent = n + ' ' + (n === 1 ? strings.one : strings.many);
      total += n;
    });

    if (countEl) countEl.textContent = total + ' ' + (total === 1 ? strings.one : strings.many);
    if (emptyEl) emptyEl.hidden = total !== 0;

    // The one in the toolbar appears only while something is filtered; the
    // one inside the empty state is the way out of it and always shows.
    var filtering = !!query || active.brand.length || active.stage.length || active.type.length;
    clears.forEach(function (b) {
      if (b.closest('.rd-instr__meta')) b.hidden = !filtering;
    });
  }

  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      var facet = chip.getAttribute('data-rd-facet');
      var value = chip.getAttribute('data-rd-value');
      var list = active[facet];
      if (!list) return;
      var i = list.indexOf(value);
      if (i === -1) list.push(value); else list.splice(i, 1);
      chip.setAttribute('aria-pressed', i === -1 ? 'true' : 'false');
      chip.classList.toggle('is-on', i === -1);
      apply();
    });
  });

  if (input) {
    var t;
    input.addEventListener('input', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        query = input.value.trim().toLowerCase();
        apply();
      }, 120);
    });
  }

  clears.forEach(function (btn) {
    btn.addEventListener('click', function () {
      active = { brand: [], stage: [], type: [] };
      query = '';
      if (input) input.value = '';
      chips.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); c.classList.remove('is-on'); });
      apply();
      if (input) input.focus();
    });
  });

  /* Brand jump links resolve here rather than in Liquid: the group ids are
     slugged by the port tool, and re-deriving the same slug in two places is
     how they end up subtly different. First group whose heading starts with
     the brand wins. */
  [].slice.call(root.querySelectorAll('[data-rd-jump]')).forEach(function (a) {
    var brand = a.getAttribute('data-rd-jump');
    var target = groups.filter(function (g) {
      var h = g.querySelector('h2');
      return h && (h.textContent || '').trim().toLowerCase().indexOf(brand.toLowerCase()) === 0;
    })[0];
    if (!target) { a.hidden = true; return; }
    a.setAttribute('href', '#' + target.id);
  });

  if (panel) panel.hidden = false;
  apply();
})();
